const borders = {
  borders: ['0.0625rem solid'], // Can be used for border-top, border-right, border-bottom, border-left
  borderWidths: ['0.0625rem'],
  borderStyles: ['solid'],
};

export default borders;
